import { SessionsService } from "./implementations/sessions.service.js";

export default defineNuxtPlugin((nuxtApp) => {
  const sessions = new SessionsService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      sessions: sessions,
    },
  };
});
